







































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import Auth from "@/store/auth";
import ConfirmModal from "@/components/modal/Confirm.vue";

@Component
export default class AppNavbar extends Vue {
  @Emit("onToggleSidebar")
  async onToggleSidebar() {}

  title: string = "";

  get user() {
    return Auth.query().first() || {};
  }

  async onSignout() {
    return (this.$refs.confirmModal as ConfirmModal).open();
  }
  async onConfirmSignout() {
    await Auth.api().signout();
    this.$router.replace({ path: "/auth" });
  }

  @Watch("$route")
  async route(to: any, from: any) {
    this.setTitle(to.meta.title);
  }

  async created() {
    this.setTitle(this.$route.meta.title);
  }

  setTitle(title: string) {
    document.title = title;
    this.title = title;
  }
}
